import React from 'react';
import { Link } from 'react-router-dom';
import { Disclosure, Transition } from '@headlessui/react';
import PageTitle from '../components/ui/PageTitle';

const faqs = [
     {
          question: 'What kind of equipment will I be renting?',
          answer: 'Ripout Rentals™ provides professional tile removal equipment. Our tools are highly specialized and tailored specifically to tile removal. The type and quality of machinery we rent out is not available at most rental yards or big box rental area. No other company rents out a full tile removal package!',
     },
     {
          question:
               'Some of this demolition equipment seems complicated, do I need special training?',
          answer: "No formal training is required. The equipment is designed to be straightforward to use. At pickup or delivery, we'll provide a brief overview of the main tool operation and key safety considerations so you can get started with confidence.",
     },
     {
          question: 'How do I book a rental?',
          answer: 'You can call us during normal business hours (9 am -5 pm) to set up your equipment rental. Alternatively, you can click on "Book Now" in the navigation menu above. The schedule is updated frequently, however, not a guarantee the date is available. Your requested date on the schedule is not confirmed until we have received your deposit and sent you your confirmation email.',
     },
     {
          question: 'Where do I pick up the tile removal tools?',
          answer: 'We can deliver the equipment directly to your project for a fee when you rent our full "package" setups utilizing the complete tile removal system. We also offer pickup at our East Mesa location if you have the ability or prefer to handle transportation yourself.',
     },
     {
          question:
               'I have never removed tile before, how long will I need to rent the equipment?',
          answer: 'To give perspective, a fully trained professional tile removal company can rip out 850-1000+ sqft in a day. Depending on the package you rent, and how much help you can round up, an 850 sqft project may take you 2 days.',
     },
];

export default function Faq() {
     return (
          <>
               <PageTitle
                    firstWord='Frequently'
                    secondWord='Asked Questions'
                    breadcrumbLink='FAQ'
               />
               <div className='mx-auto max-w-7xl px-6 py-12 laptop:py-40 laptop:px-8'>
                    <div className='laptop:grid laptop:grid-cols-12 laptop:gap-8'>
                         <div className='laptop:col-span-5'>
                              <div className='sticky top-32'>
                                   <h1 className='origin-left text-dark uppercase font-bold text-[40px] leading-[2.5rem] mb-3 whitespace-nowrap'>
                                        <span className='block text-[30px] text-yellow'>
                                             You've got questions,
                                        </span>
                                        We've got answers.
                                   </h1>
                                   <p className='mt-8'>
                                        Can't find the answer you're looking
                                        for? Reach out to our{' '}
                                        <Link
                                             to='#'
                                             onClick={(e) => {
                                                  window.location.href =
                                                       'mailto:sales@ripoutrentals.com';
                                                  e.preventDefault();
                                             }}
                                             className='font-semibold text-yellow'
                                        >
                                             customer support
                                        </Link>{' '}
                                        team, 602-362-4644
                                   </p>
                              </div>
                         </div>
                         <div className='mt-10 laptop:col-span-7 laptop:mt-0'>
                              <dl className='space-y-4'>
                                   {faqs.map((faq) => (
                                        <Disclosure key={faq.question}>
                                             {({ open }) => (
                                                  <div className={`rounded-2xl border ${open ? 'border-yellow bg-yellow/5' : 'border-gray-200'} duration-300`}>
                                                       <Disclosure.Button className='flex w-full items-center justify-between px-6 py-5 text-left'>
                                                            <dt className='text-xl font-semibold leading-7 text-darker pr-4'>
                                                                 {faq.question}
                                                            </dt>
                                                            <span className={`text-yellow text-2xl flex-shrink-0 duration-300 ${open ? 'rotate-45' : ''}`}>
                                                                 +
                                                            </span>
                                                       </Disclosure.Button>
                                                       <Transition
                                                            enter='duration-200 ease-out'
                                                            enterFrom='opacity-0 max-h-0'
                                                            enterTo='opacity-100 max-h-96'
                                                            leave='duration-150 ease-in'
                                                            leaveFrom='opacity-100 max-h-96'
                                                            leaveTo='opacity-0 max-h-0'
                                                       >
                                                            <Disclosure.Panel className='overflow-hidden'>
                                                                 <dd className='px-6 pb-5 leading-7 text-darker/80'>
                                                                      {faq.answer}
                                                                 </dd>
                                                            </Disclosure.Panel>
                                                       </Transition>
                                                  </div>
                                             )}
                                        </Disclosure>
                                   ))}
                              </dl>
                         </div>
                    </div>
               </div>
          </>
     );
}
